import type { FaireProductEntity } from "../../entity_types/product";

export const p_wte4wggqd9: FaireProductEntity = {
  token: "p_wte4wggqd9",
  type: "product",
  name: "Magnesium Oil Spray",
  brandToken: "b_cm73zmtk8g",
  brandName: "Sage & Stone Apothecary",
  imageUrl:
    "https://cdn.faire.com/fastly/84ffdf1481d7393f5673ef635f40274f30e6dc435ca2aa7e635c7cde9bdd3f6b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/18b3fa01c573338b2ae0a06aca063fd6a9a00e6f0a717520218bc0ea2193990e.jpeg",
  ],
  priceDollars: 11.5,
  description:
    " Embrace the Power of Magnesium Oil \n\n🌟 Magnesium is an essential mineral that plays a vital role in our overall well-being. From promoting relaxation and better sleep to supporting muscle recovery and reducing stress, it's no wonder why this mineral is gaining so much attention.\n\n💦 But have you ever tried Magnesium Oil? This magical elixir is a convenient and effective way to reap the benefits of magnesium topically. Just a few sprays can work wonders for both your body and mind!\n\n🌿 Magnesium Oil is easily absorbed through the skin, bypassing the digestive system and delivering its soothing properties directly to your muscles and tissues. Its powerful anti-inflammatory properties can help alleviate muscle cramps, joint pain, and even headaches. Say goodbye to discomfort and hello to natural relief! 💪🏻\n\n✨ Not only does Magnesium Oil work wonders for your physical well-being, but it's also a game-changer for relaxation. When applied before bed, it can help you unwind, ease tension, and promote a more restful sleep. Wake up feeling rejuvenated and ready to conquer the day! 😴\n\n🌟 So, why not add this incredible mineral to your self-care routine? Whether you're an athlete looking for muscle recovery or someone seeking a natural way to relax, Magnesium Oil has got you covered. It's time to give your body the love and care it deserves!\n\n\n\n\n\n",
  tags: [],
  msrpDollars: 23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:41.960Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
